import FadeUp from "./FadeUp";
export default FadeUp;